import React, { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import styles from './styles.less';
import { Button } from './Button';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearError } from '../ducks/error';
import { supportBase } from '../config';
import { pricingSelector } from '../reducers/selectors';
import blurb_svg from '../public/blurb.svg';

function GenericError({
  error,
  resetErrorBoundary,
  theError,
  pricing,
  maintenance,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClearAndNavigate = useCallback(() => {
    dispatch(clearError());
    navigate('/');
  }, [dispatch, navigate]);

  const handleTryAgain = useCallback(() => {
    dispatch(clearError());
    if (maintenance) {
      location.href = '/';
    } else {
      location.reload();
    }
  }, [dispatch, location, maintenance]);

  function GoToLibraryButton() {
    return (
      <Button
        variant="primary"
        width="var(--primary-button-width)"
        onClick={handleClearAndNavigate}
      >
        Go to my projects
      </Button>
    );
  }

  function TryAgainButton() {
    return (
      <Button
        variant="primary"
        width="var(--primary-button-width)"
        onClick={handleTryAgain}
      >
        Try Again
      </Button>
    );
  }

  function getErrorMessage() {
    if (theError.get('maintenanceMode') || maintenance) {
      return {
        header: t('ERROR.MAINTENANCE_HEADER'),
        message: 'ERROR.MATINENANCE_MESSAGE',
      };
    } else if (pricing && pricing.error) {
      return {
        header: t('ERROR.UNHANDLED_GENERIC_HEADER'),
        message: 'ERROR.PRICING_ERROR_CREATE_PROJECT',
      };
    }
    return {
      header: t('ERROR.UNHANDLED_GENERIC_HEADER'),
      message: 'ERROR.UNHANDLED_GENERIC_DETAIL',
    };
  }
  const errorMessage = getErrorMessage();
  return (
    <div className={styles.errorContainer}>
      <img src={blurb_svg} alt="Blurb Logo" style={{ height: 64 }} />
      <div className={styles.headerTitle}>{errorMessage.header}</div>
      <div>
        <Trans
          i18nKey={errorMessage.message}
          components={[<a target="_blank" href={supportBase} />]}
        />
      </div>
      <div className={styles.ctaContainer}>
        {!theError.get('maintenanceMode') && !maintenance && (
          <GoToLibraryButton />
        )}
        <TryAgainButton />
      </div>
    </div>
  );
}

export default connect((state) => ({
  theError: state.error,
  pricing: pricingSelector(state),
}))(GenericError);
